import { ContactForm } from './ContactForm';
import { Panz } from './Panz';

const PHONE = '970-257-9393';

const PROCESSES = [
  {
    name: 'Anodize',
    spec: (
      <>
        MIL-A-8625 <small />
        <br />
        Type II &amp; III
        <br />
        Clear, Black, Red, Blue
        <br />
        <small>other colors available upon request</small>
      </>
    ),
    tableSpec: (
      <>
        MIL-A-8625 (Type II &amp; III)
        <br />
        Clear, Black, Red, Blue
        <br />
        <small>(Other colors available upon request)</small>
      </>
    ),
    nadcap: false,
    detail: (
      <p>
        Anodize Type II: Anodizing is an electrochemical process that converts an aluminum surface
        into a decorative, durable, corrosion resistant, anodic finish. Hard Coat Anodize Type III:
        Hard coat anodized coatings are typically applied to heavy wear, industrial parts intended
        for use in aggressive or highly corrosive applications. These coatings are typically far
        thicker and harder than Type II.
      </p>
    ),
  },
  {
    name: 'Black Oxide',
    spec: (
      <>
        MIL-DTL-13924 <br />
        Steel and Stainless Steel
      </>
    ),
    tableSpec: (
      <>
        MIL-DTL-13924 <br />
        Steel and Stainless Steel
      </>
    ),
    nadcap: false,
    detail: (
      <p>
        This process consists of a hot alkaline nitrate black oxide bath. The coating provides a
        deep black and low surface build up. The coating is also supplied with subsequent oils to
        provide moderate corrosion resistance.
      </p>
    ),
  },
  {
    name: 'Chem Film',
    spec: (
      <>
        MIL-DTL-5541
        <br />
        Class 1A &amp; Class 3
      </>
    ),
    tableSpec: (
      <>
        MIL-DTL-5541
        <br />
        Class 1A &amp; Class 3
      </>
    ),
    nadcap: true,
    detail: (
      <p>
        Chem Film is a conversion coating that can be applied to aluminum to offer corrosion
        resistance, increased adhesion properties, and can be achieved without adding discernable
        thickness or altering the part.
        <br />
        <strong>Class 1A:</strong> Maximum Corrosion Resistance
        <br />
        <strong>Class 3:</strong> For lower electrical resistance
      </p>
    ),
  },
  {
    name: 'Zinc',
    spec: (
      <>
        ASTM-B-633
        <br />
        Clear, Yellow, Black
      </>
    ),
    tableSpec: (
      <>
        ASTM-B-633
        <br />
        Clear, Yellow, Black
      </>
    ),
    nadcap: false,
    detail: (
      <p>
        Zinc plating is a widely used coating applied to steel that provides corrosion resistance
        and reduces abrasion and wear. For your convenience we do both barrel and rack plating.
      </p>
    ),
  },
];

function Header() {
  return (
    <div>
      <div
        id="introBack"
        style={{ backgroundColor: 'black', marginTop: 5, marginLeft: 5, paddingTop: 15 }}
      >
        <div
          id="intro"
          className="text-left"
          style={{ marginLeft: 15, backgroundColor: 'black' }}
        >
          <img title="Precision Metal Finishing" style={{ maxHeight: 100 }} src="/logo.jpg" alt="Precision Metal Finishing" />
          <a target="_blank" rel="noreferrer" href="/certs.pdf">
            <img
              title="Nadcap certified chemical and aerospace metal finishing"
              className="pull-right visible-lg visible-md nadcapImg"
              src="/cert1-thumb.png"
              alt="Nadcap certification"
            />
            <img
              title="Nadcap certified chemical and aerospace metal finishing"
              className="pull-right visible-lg visible-md nadcapImg"
              src="/cert2-thumb.png"
              alt="Nadcap certification"
            />
          </a>
        </div>
      </div>

      <div id="panel-nav" style={{ marginBottom: 0 }}>
        <div className="panel-nav-body">
          <div className="row">
            <div className="col-md-4">
              <a href="#contact" className="btn btn-lg btn-default btn-block pull-right">
                <i className="glyphicon glyphicon-list-alt" /> Request Quote
              </a>
            </div>
            <div className="col-md-4">
              <a
                href="#contact"
                className="btn btn-lg btn-default btn-block pull-right visible-lg visible-md"
              >
                <i className="glyphicon glyphicon-earphone" /> Call {PHONE}
              </a>
              <a
                href={`tel:${PHONE}`}
                className="btn btn-lg btn-default btn-block pull-right visible-sm visible-xs"
              >
                <i className="glyphicon glyphicon-earphone" /> Call
              </a>
            </div>
            <div className="col-md-4">
              <a href="#contact" className="btn btn-lg btn-default btn-block pull-right">
                <i className="glyphicon glyphicon-envelope" /> Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Processes() {
  return (
    <div id="introContainer" style={{ position: 'absolute', top: 350, left: 'auto', right: 'auto' }}>
      <a id="processes" />
      <div id="processesContainer" style={{ marginTop: 0 }}>
        <div
          id="processesContainerData"
          className="container"
          style={{
            minHeight: 735,
            borderRadius: 25,
            borderBottomRightRadius: 5,
            borderBottomLeftRadius: 5,
          }}
        >
          <h1 style={{ marginBottom: 30, fontWeight: 900 }} className="text-center">
            Metal Processes
          </h1>

          <div id="processesIntro" className="row">
            {PROCESSES.map((p) => (
              <div className="col-md-3" key={p.name}>
                <div className="panel panel-primary">
                  <div className="panel-heading" style={{ fontSize: 22 }}>
                    {p.name}
                  </div>
                  <div className="panel-body">{p.spec}</div>
                  {p.nadcap && (
                    <a target="_blank" rel="noreferrer" href="/certs.pdf">
                      <img
                        className="thumbnail img-responsive"
                        style={{
                          maxHeight: 30,
                          position: 'absolute',
                          top: 30,
                          right: 20,
                          border: 'thin solid black',
                          marginTop: 5,
                        }}
                        src="/nadcaplogo2.png"
                        alt="Nadcap"
                      />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 30 }} className="panel panel-default visible-md visible-lg">
            <div className="panel-body">
              <table className="table table-bordered table-responsive table-striped">
                <tbody>
                  {PROCESSES.map((p) => (
                    <tr key={p.name}>
                      <td style={{ width: 150 }}>
                        <strong>{p.name}</strong>
                        {p.nadcap && (
                          <a target="_blank" rel="noreferrer" href="/certs.pdf">
                            <img
                              className="thumbnail img-responsive"
                              style={{ maxHeight: 30, border: 'thin solid black', marginTop: 5 }}
                              src="/nadcaplogo2.png"
                              alt="Nadcap"
                            />
                          </a>
                        )}
                      </td>
                      <td style={{ width: 250 }}>{p.tableSpec}</td>
                      <td>{p.detail}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Contact() {
  return (
    <div style={{ paddingTop: 0, paddingBottom: 0, margin: 50 }} id="contactContainer">
      <a id="contact" />
      <div
        className="container"
        style={{
          backgroundColor: '#3377c0',
          boxShadow: '3px 5px 10px black',
          padding: 5,
          position: 'relative',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            marginBottom: 2,
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
            border: 'thin solid black',
          }}
        >
          <div className="row">
            <div style={{ padding: 20 }} className="col-xs-9">
              <div className="row">
                <div className="col-md-1">
                  <span className="visible-md visible-lg">
                    <i
                      style={{ fontSize: 34, marginLeft: 20 }}
                      className="glyphicon glyphicon-envelope text-warning"
                    />
                  </span>
                  <span className="visible-sm visible-xs">
                    <i
                      style={{ fontSize: 15, marginLeft: 5 }}
                      className="glyphicon glyphicon-envelope text-warning"
                    />{' '}
                    Request a quote
                  </span>
                </div>
                <div className="col-md-11">
                  <div className="visible-lg visible-md">
                    <h2 style={{ display: 'inline', fontWeight: 100 }}>
                      Request a quote or ask a question.
                    </h2>
                    <p>Send us your print for a quick quote</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-3" />
          </div>
        </div>

        <ContactForm />
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div style={{ backgroundColor: 'white', padding: 20 }}>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div style={{ marginTop: 70 }} className="row">
              <div className="col-md-6">
                <img
                  title="Precision Metal Finishing"
                  className="img-responsive"
                  src="/logo.jpg"
                  alt="Precision Metal Finishing"
                />
              </div>
              <div className="col-md-6">
                <address style={{ width: '100%', display: 'block', marginTop: 15 }}>
                  <strong>Precision Metal Finishing LLC</strong>
                  <br />
                  850 South Ave. Unit B <br />
                  Grand Junction, CO 81501
                  <br />
                  <abbr title="Phone">
                    <strong>P:</strong>
                  </abbr>{' '}
                  <strong>(970) 257-9393</strong>{' '}
                  <abbr title="Fax">
                    <strong>F:</strong>
                  </abbr>{' '}
                  <strong>(970) 549-4206</strong>
                </address>
              </div>
            </div>

            <hr />
            <h3 className="text-center" style={{ marginTop: 30 }}>
              Hours Of Operation <br /> Monday-Thursday
              <br /> 9am - 5pm
            </h3>
            <hr style={{ marginTop: 10 }} />
            <div className="text-center">
              <img style={{ maxHeight: 100 }} src="/nadcaplogo2.png" alt="Nadcap" />
              <a style={{ backgroundColor: 'white' }} target="_blank" rel="noreferrer" href="/certs.pdf">
                <img
                  title="Nadcap certified chemical and aerospace metal finishing"
                  className="pull-right nadcapImg"
                  src="/cert1-thumb.png"
                  alt="Nadcap certification"
                />
                <img
                  title="Nadcap certified chemical and aerospace metal finishing"
                  className="pull-right nadcapImg"
                  src="/cert2-thumb.png"
                  alt="Nadcap certification"
                />
              </a>
            </div>
          </div>
          <div className="col-md-6" style={{ borderLeft: 'thin solid #3377c0' }}>
            <iframe
              title="Precision Metal Finishing location"
              style={{
                marginTop: 50,
                marginBottom: 50,
                border: 'thin solid black',
                width: '100%',
                height: 450,
              }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3097.877972908131!2d-108.56043368464476!3d39.06369497954544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87471c65ff4d2fd5%3A0x10b2729e56368159!2s850+South+Ave%2C+Grand+Junction%2C+CO+81501!5e0!3m2!1sen!2sus!4v1449469421656"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function App() {
  return (
    <>
      <Header />

      <div
        style={{
          backgroundColor: 'white',
          padding: 20,
          fontSize: 30,
          fontWeight: 'bolder',
          borderTop: '30px solid #3377c0',
        }}
        className="text-center visible-lg visible-md"
      >
        <i className="glyphicon glyphicon-asterisk pmfBlue" /> Quality Means Conformance To Our
        Customer&apos;s Requirements <i className="glyphicon glyphicon-asterisk pmfBlue" />
      </div>

      <Panz />

      <Processes />

      <Contact />

      <Footer />

      <div style={{ height: 300 }} />
      <nav className="navbar navbar-default navbar-fixed-bottom">
        <div className="container text-center text-muted" />
      </nav>
    </>
  );
}
